import React, { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from 'react-icons/fa';

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();

    // Close mobile menu when route changes
    useEffect(() => {
        setIsOpen(false);
    }, [location]);

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isOpen && !event.target.closest('.mobile-menu')) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen]);

    // Prevent scrolling when mobile menu is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    const navLinks = [
        { to: "#home", text: "Home" },
        { to: "#about", text: "About Us" },
        { to: "#services", text: "Services" },
        { to: "#why-us", text: "Why Us" },
    ];

    const scrollToSection = (e, path) => {
        // If it's a hash link (starts with #)
        if (path.startsWith('#')) {
            e.preventDefault();
            const element = document.querySelector(path);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };

    return (
        <header className="w-full bg-white shadow-md">
            <nav className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16 sm:h-20">
                    {/* Logo */}
                    <Link 
                        to="/" 
                        onClick={(e) => {
                            e.preventDefault();
                            window.location.href = '/';
                        }} 
                        className="flex-shrink-0 cursor-pointer"
                    >
                        <img
                            src="assets/images/header-logo.png"
                            alt="BluePeak Realty"
                            className="h-12 sm:h-14 md:h-16 w-auto transition-all duration-200"
                        />
                    </Link>

                    {/* Desktop Navigation */}
                    <div className="hidden md:flex items-center space-x-2 lg:space-x-6 xl:space-x-8">
                        {navLinks.map((link) => (
                            <a
                                key={link.to}
                                href={link.to}
                                onClick={(e) => scrollToSection(e, link.to)}
                                className="text-gray-700 hover:text-[#041C77] px-2 sm:px-3 py-2 text-sm sm:text-[15px] font-medium transition-colors duration-200 cursor-pointer"
                            >
                                {link.text}
                            </a>
                        ))}
                        <a
                            href="#contact"
                            onClick={(e) => scrollToSection(e, '#contact')}
                            className="ml-2 sm:ml-4 bg-[#041C77] text-white px-4 sm:px-6 py-2 rounded-full text-sm sm:text-[15px] font-medium hover:bg-opacity-90 transition-all whitespace-nowrap cursor-pointer"
                        >
                            Contact Us
                        </a>
                    </div>

                    {/* Mobile menu button */}
                    <div className="md:hidden flex items-center">
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-[#041C77] focus:outline-none"
                            aria-expanded="false"
                        >
                            <span className="sr-only">Open main menu</span>
                            {isOpen ? (
                                <FaTimes className="block h-6 w-6" aria-hidden="true" />
                            ) : (
                                <FaBars className="block h-6 w-6" aria-hidden="true" />
                            )}
                        </button>
                    </div>
                </div>
            </nav>

            <div
                className={`fixed inset-0 bg-white z-40 transform ${isOpen ? 'translate-x-0' : 'translate-x-full'} 
                    md:hidden transition-transform duration-300 ease-in-out pt-16 px-4`}
            >
                <div className="px-2 pt-2 pb-3 space-y-2 sm:px-3">
                    {navLinks.map((link) => (
                        <a
                            key={link.to}
                            href={link.to}
                            onClick={(e) => {
                                setIsOpen(false);
                                scrollToSection(e, link.to);
                            }}
                            className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100"
                        >
                            {link.text}
                        </a>
                    ))}
                    <a
                        href="#contact"
                        onClick={(e) => {
                            setIsOpen(false);
                            scrollToSection(e, '#contact');
                        }}
                        className="block w-full text-center px-4 py-2 mt-2 text-sm font-medium text-white bg-[#041C77] rounded-md hover:bg-opacity-90"
                    >
                        Contact Us
                    </a>
                </div>
            </div>
        </header>
    );
};
export default Header;
